import React, { useState } from 'react';
import axios from 'axios';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import { Modal, Button, Form } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './LoginForm.css';
import { useUser } from '../UserContext';

const LoginForm = ({ onClose }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [username, setUsername] = useState('');
    const [error, setError] = useState('');
    const [googleToken, setGoogleToken] = useState('');
    const [errorLogin, setErrorLogin] = useState('');
    const { user, setUser } = useUser();

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post('/api/auth/login.php', { email, password });
            // handle successful login
			  if (response.data.status === 'success') {
				localStorage.setItem('token', response.data.token);
				setUser({
				  userid: response.data.userid,
				  username: response.data.username,
				  rank: '',
                  mod: response.data.mod,
				  token: response.data.token,
				  profile_picture: response.data.picture,
				});
                console.log(user);
				onClose();
			  } else {
			                setErrorLogin(response.data.message);
			  }
			
        } catch (error) {
            // handle login error
            console.error(error);
        }
    };

    const handleGoogleSuccess = async (credentialResponse) => {
        const token = credentialResponse.credential;
        setGoogleToken(token);  // Save the token in state
        try {
            const response = await axios.post('/api/auth/google-login.php', { token });
            if (response.data.status === 'success') {
                // handle successful Google login
                console.log(response.data);
			if (response.data.status === 'success') {
				localStorage.setItem('token', response.data.token);
				setUser({
				  userid: response.data.userid,
				  username: response.data.username,
				  rank: '',
                  mod: response.data.mod,
				  token: response.data.token,
				  profile_picture: response.data.picture,
				});
				onClose();
			  }
				
            } else if (response.data.status === 'new_user') {
                // Prompt user for a username
                setShowModal(true);
            }
        } catch (error) {
            // handle Google login error
            console.error(error);
        }
    };

    const handleGoogleFailure = (error) => {
        console.error(error);
        // handle Google login failure
    };

    const handleUsernameSubmit = async () => {
        try {
            const registerRes = await axios.post('/api/auth/google-register.php', { token: googleToken, username });
            if (registerRes.data.status === 'success') {
                // handle successful Google registration
                console.log(registerRes.data);
                setShowModal(false);
				localStorage.setItem('token', registerRes.data.token);
				setUser({
				  userid: registerRes.data.userid,
				  username: registerRes.data.username,
				  rank: '',
				  token: registerRes.data.token,
				  profile_picture: registerRes.data.picture,
				});
				onClose();
				
            } else {
                // handle registration error
                setError(registerRes.data.message);
            }
        } catch (error) {
            // handle registration error
            console.error(error);
        }
    };


    return (
        <section className="vh-100 login-form-main">
            <button
                type="button"
                className="btn-close position-absolute top-0 end-0 m-3"
                aria-label="Close"
                onClick={onClose}
            ></button>
            <div className="container py-5 h-100">
                <div className="row d-flex align-items-center justify-content-center h-100">
                    <div className="loginFormLeft col-md-8 col-lg-7 col-xl-6">
                        <img
                            src="/images/login-portal.webp"
                            className="img-fluid"
                            alt="Phone image"
                        />
                    </div>
                    <div className="loginFormRight col-md-7 col-lg-5 col-xl-5 offset-xl-1 position-relative">
                        <div className="mb-4 d-flex justify-content-center">
                            <img src="/images/hearthcards-logo.webp" className="img-fluid" style={{ maxHeight: '100px' }} alt="Logo" />
                        </div>
                        <form onSubmit={handleLogin}>
                            <div className="form-outline mb-4">
                                <input
                                    type="email"
                                    id="form1Example13"
                                    className="form-control form-control-lg"
                                    placeholder="Email address"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </div>

                            <div className="form-outline mb-4">
                                <input
                                    type="password"
                                    id="form1Example23"
                                    className="form-control form-control-lg"
                                    placeholder="Password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                            </div>

                            <div className="d-flex justify-content-around align-items-center mb-4">
                                <div className="form-check">
                                    <input className="form-check-input" type="checkbox" id="form1Example3" checked />
                                    <label className="form-check-label" htmlFor="form1Example3"> Remember me </label>
                                </div>
                                <a href="/registration.php">Register</a>
                                {/* <a href="#!">Forgot password?</a> */}
                            </div>

                            <button type="submit" className="btn btn-primary btn-lg btn-block w-100">Sign in</button>
							{errorLogin && <div className="alert alert-danger my-4">{errorLogin}</div>}
                            <div className="divider d-flex align-items-center my-4">
                                <p className="text-center fw-bold mx-3 mb-0 text-muted">OR</p>
                            </div>
                            <div className="d-flex justify-content-center">
                                <GoogleOAuthProvider clientId="54032069333-urga89k8e45rtegbakujps06d4c9qr2p.apps.googleusercontent.com">
                                    <GoogleLogin
                                        onSuccess={handleGoogleSuccess}
                                        onFailure={handleGoogleFailure}
                                        theme="filled_blue"
                                        render={(renderProps) => (
                                            <button
                                                onClick={renderProps.onClick}
                                                disabled={renderProps.disabled}
                                                className="btn btn-primary btn-lg btn-block w-100"
                                                style={{ backgroundColor: '#db4a39' }}
                                            >
                                                <i className="fab fa-google me-2"></i>Continue with Google
                                            </button>
                                        )}
                                    />
                                </GoogleOAuthProvider>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Choose a Username</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3" controlId="username">
                    <div className="container mb-4 d-flex justify-content-center">
                        <img
                            src="/images/username-garrosh.webp"
                            className="img-fluid"
                            alt="Phone image"
							style={{ maxHeight: '250px' }}
                        />
                    </div>
                            <Form.Label>To use HearthCards you need to pick a Username</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter username"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                            />
                            {error && <Form.Text className="text-danger">{error}</Form.Text>}
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>

                    <Button variant="primary" onClick={handleUsernameSubmit}>
                        Choose
                    </Button>
                </Modal.Footer>
            </Modal>
        </section>
    );
};

export default LoginForm;
